import { ScrolledGrid } from './ScrolledGrid';

export type { TypeScrolledGridProps } from './types';
export default ScrolledGrid;
